import axios from "../lib/axios";

export const TYPES = {
  UPDATE_SELECTED_ITEMS_IDS: "UPDATE_SELECTED_ITEMS_IDS",
  SET_PENDING_CLOSET_SALES: "SET_PENDING_CLOSET_SALES",
  RESET_BUY_ITEMS: "RESET_BUY_ITEMS",
};

function updateSelectedItemsIds(itemsIds) {
  return {
    type: TYPES.UPDATE_SELECTED_ITEMS_IDS,
    itemsIds,
  };
}

function setPendingClosetSales(pendingClosetSales) {
  return {
    type: TYPES.SET_PENDING_CLOSET_SALES,
    pendingClosetSales,
  };
}

export function resetBuyItems() {
  return { type: TYPES.RESET_BUY_ITEMS };
}

export function selectItems(itemsIds) {
  return async (dispatch) => {
    dispatch(updateSelectedItemsIds(itemsIds));
  };
}

function getBuyItems(closetId, selectedItemsIds, redeemName, usePurchaseCredit) {
  return async (dispatch) => {
    try {
      const apiRes = await axios.get(`closets/${closetId}/buy_closet_items`, { params: { closet_item_ids: selectedItemsIds, redeem_name: redeemName, use_purchase_credits: usePurchaseCredit } });

      const dispatchedRes = dispatch(setPendingClosetSales(apiRes.data.data));

      return dispatchedRes.pendingClosetSales;
    } catch (err) {
      dispatch(setPendingClosetSales({}));

      return {};
    }
  };
}

export function toggleSelectedItem(itemId) {
  return async (dispatch, getState) => {
    const { selectedItemsIds, pendingClosetSales } = getState().buyClosetItems;
    const closetId = pendingClosetSales?.id;
    const usePurchaseCredit = pendingClosetSales?.summary?.use_purchase_credits;
    const couponName = pendingClosetSales?.summary?.coupon?.name;

    let itemsIds;

    if (selectedItemsIds.includes(itemId)) {
      itemsIds = selectedItemsIds.filter((id) => id !== itemId);
    } else {
      itemsIds = [...selectedItemsIds, itemId];
    }

    dispatch(updateSelectedItemsIds(itemsIds));
    dispatch(getBuyItems(closetId, itemsIds, couponName, usePurchaseCredit));
  };
}

export function toggleUsePurchaseCredit() {
  return async (dispatch, getState) => {
    const { selectedItemsIds, pendingClosetSales } = getState().buyClosetItems;
    const closetId = pendingClosetSales?.id;
    const usePurchaseCredit = pendingClosetSales?.summary?.use_purchase_credits;
    const couponName = pendingClosetSales?.summary?.coupon?.name;

    const toggledUsePurchaseCredit = !usePurchaseCredit;

    dispatch(getBuyItems(closetId, selectedItemsIds, couponName, toggledUsePurchaseCredit));
  };
}

export function updateCoupon(couponName) {
  return async (dispatch, getState) => {
    const { selectedItemsIds, pendingClosetSales } = getState().buyClosetItems;
    const closetId = pendingClosetSales?.id;
    const usePurchaseCredit = pendingClosetSales?.summary?.use_purchase_credits;

    dispatch(getBuyItems(closetId, selectedItemsIds, couponName, usePurchaseCredit));
  };
}

export function reloadBuyItems(closetId) {
  return async (dispatch, getState) => {
    const { selectedItemsIds, pendingClosetSales } = getState().buyClosetItems;
    const couponName = pendingClosetSales?.summary?.coupon?.name || null;
    const usePurchaseCredit = pendingClosetSales?.summary
      ? pendingClosetSales?.summary?.use_purchase_credits
      : true;

    const res = dispatch(getBuyItems(closetId, selectedItemsIds, couponName, usePurchaseCredit));

    return res;
  };
}
